import { IS_DEV } from '../utils/config'

const loadScript = (src) => {
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')
  script.type = 'text/javascript'
  return new Promise((re) => {
    if (script.readyState) {
      // other
      script.onreadystatechange = function () {
        if (this.readyState === 'complete' || script.readyState === 'loaded') {
          script.onreadystatechange = null
          re()
        }
      }
    } else {
      // other
      script.onload = function () {
        re()
      }
    }
    script.src = src
    head.appendChild(script)
  })
}

const src = 'https://cdn.paddle.com/paddle/paddle.js'
const vendor = 102673
const sandBoxVendor = 681
let isInit = false

const eventCallback = []

const onPaddleEventCallback = (...args) => {
  eventCallback.forEach((c) => c.call(c, ...args))
}

const addPaddleEventCallback = (fn) => {
  eventCallback.push(fn)
}

const init = () => {
  return new Promise((re) => {
    if ('Paddle' in window) {
      re()
    } else {
      loadScript(src).then(re)
    }
  }).then((_) => {
    if (!isInit) {
      let setupVendor = vendor
      if (IS_DEV) {
        window['Paddle'].Environment.set('sandbox')
        setupVendor = sandBoxVendor
      }
      window['Paddle'].Setup({
        vendor: setupVendor,
        eventCallback: onPaddleEventCallback,
      })
      isInit = true
    }
    return true
  })
}

const pay = (payLink) => {
  window['Paddle'].Checkout.open({
    checkoutVariant: {
      isForced: true,
    },
    override: payLink,
  })
  return new Promise((re) => {
    addPaddleEventCallback((data) => {
      console.log(data)
      if (data.event === 'Checkout.Close') {
        re({ status: 'Close' })
      }
      if (data.event === 'Checkout.Complete') {
        re({ status: 'Complete' })
      }
    })
  })
}

const updatePayment = (updateUrl) => {
  window['Paddle'].Checkout.open({
    checkoutVariant: {
      isForced: true,
    },
    override: updateUrl,
  })
  return new Promise((re) => {
    addPaddleEventCallback((data) => {
      if (data.event === 'Checkout.PaymentMethodSelected') {
        re()
      }
    })
  })
}

const paddle = {
  init,
  addPaddleEventCallback,
  updatePayment,
  pay,
}

export default paddle
